<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <vxe-table
          border
          keep-source
          show-overflow
          class="table-style"
          :auto-resize="true"
          ref="xTable"
          max-height="500"
          :show-footer="true"
          :edit-rules="validRules"
          :data="formData"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
      >
        <vxe-table-column width="40" align="center">
          <template v-slot:header>
            <Button
                class="add-btn"
                icon="md-add"
                @click="insertEvent()"
            ></Button>
          </template>
          <template v-slot="{ row, $rowIndex }">
            <Button
                class="del-btn"
                icon="md-remove"
                @click="removeEvent(row, $rowIndex)"
            ></Button>
          </template>
        </vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
            title="关联托运人订单"
            field="buyerOrdersNum"
            width="150"
        >
          <template v-slot="{ row, $rowIndex }">
            <vxe-input v-model="row.buyerOrdersNum" placeholder="选填">
              <template v-slot:suffix>
                <span class="link-other">
                  <Icon
                      type="ios-link"
                      @click="openOrder({ i: $rowIndex, data: formData })"
                      @blur="clearTableV"
                  />
                </span>
              </template>
            </vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="合同号" field="contractNum" width="150">
          <template v-slot="{ row, $rowIndex }">
            <vxe-input v-model="row.contractNum" placeholder="选填">
              <template v-slot:suffix>
                <span class="link-other">
                  <Icon
                      type="ios-link"
                      @click="openContract({ i: $rowIndex, data: formData })"
                      @blur="clearTableV"
                  />
                </span>
              </template>
            </vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="业务员" width="150" field="salesManName">
          <template v-slot="{ row, $rowIndex }" @blur="clearTableV">
            <sales-man
                :row="row"
                :field="'salesManName'"
                :rowIndex="$rowIndex"
                :placeholder="'请选择业务员'"
                @setSaleMan="setSaleMan"
                @focus="clearValidate('xTable')"
            ></sales-man>
          </template>
        </vxe-table-column>
        <vxe-table-column title="销售经理" width="150" field="salesManNameXs">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.salesManNameXs"
                placeholder="由业务员关联"
                disabled
                @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="业务类别" width="120" field="contractBusType">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.contractBusType"
                placeholder="请选择"
                @blur="clearTableV"
                @change="contractBusChange"
                :options="contractListType"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractTitle" title="订单标题" width="150">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.contractTitle"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="托运人名称" width="150" field="buyerName">
          >
          <template v-slot="{ row }">
            <platform-corp
                :row="row"
                :field="'buyerName'"
                :placeholder="'请选择平台企业'"
                @blur="clearTableV"
            ></platform-corp>
          </template>
        </vxe-table-column>
        <vxe-table-column title="承运人名称" width="150" field="sellerName">
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                @click="openUser({ i: $rowIndex, data: formData })"
                @blur="clearTableV"
                target="_black"
            >{{
              row.sellerName === null || row.sellerName === ""
              ? "请选择账户"
              : row.sellerName
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column title="签约日期" width="120" field="addTime">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.addTime"
                placeholder="选择日期"
                type="date"
                transfer
                @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsType" title="货物类型" width="140">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.goodsType"
                placeholder="请选择"
                :options="goodsTypeOptions"
                @change="clearValidate('xTable')"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="120">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.goodsName"
                placeholder="必填"
                @input="$refs.xTable.updateStatus(scope)"
                @focus="clearValidate('xTable')"
                @blur="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="rule" title="规格" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.rule" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column field="packUnit" title="包装形式" width="110">
          <template v-slot="{ row }">
            <vxe-input v-model="row.packUnit" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="unit" title="单位" width="55">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.unit"
                placeholder="请选择"
                :options="unitTypeOptions"
                @change="clearTableV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="counts" title="数量" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.counts"
                v-on:input="inputcounts(row)"
                min="0"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="price" title="单价" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.price"
                min="0"
                placeholder="选填"
                v-on:input="inputcounts(row)"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" title="总金额" width="116">
          <template v-slot="{ row }">
            <vxe-input v-model="row.amount" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="buyerAmount" title="托运人金额" width="100">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.buyerAmount"
                :placeholder="row.contractBusType === 2 ? '必填' : '选填'"
                type="float"
                digits="2"
                @focus="clearValidate('xTable')"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="priceType" title="计费方式" width="90">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.priceType"
                placeholder="必填"
                :options="priceType"
                @change="clearValidate('xTable')"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTax" title="含税" width="90">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.isTax"
                placeholder="必填"
                :options="taxType"
                @blur="clearTableV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="carShipNum" title="车船号" width="130">
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                @click="openCarShip({ i: $rowIndex, data: formData })"
                @blur="clearTableV"
                target="_black"
            >{{
              row.carShipNum === null || row.carShipNum === ""
              ? "请选择车船"
              : row.carShipNum
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="transportationType"
            title="货运类型"
            width="90"
        >
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.transportationType"
                placeholder="必填"
                :options="transportationType"
                @blur="clearTableV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column title="交货地点" width="100">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.deliveryPoints"
              placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column title="起运地" width="100">
          <template v-slot="{ row }">
            <vxe-input v-model="row.beginPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="province" title="起运地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.province"
                :options="cityData"
                @change="loadCity(row.province, $rowIndex, 1)"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="city" title="起运地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.city"
                :options="row.cityOptions"
                @change="loadArea(row.province, row.city, $rowIndex, 1)"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="area" title="起运地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.area"
                :options="row.areaOptions"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="beginPlaceAddress"
            title="详细地址"
            width="160"
        >
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.beginPlaceAddress"
                placeholder="起运地"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="beginTime" title="受载/起运时间" width="160">
          <template v-slot="{ row }">
            <!-- <vxe-input v-model="row.beginTime" placeholder="选填"></vxe-input> -->
            <vxe-input
                v-model="row.beginTime"
                placeholder="选择日期"
                @blur="clearTableV"
                :type="row.contractBusType === 1 ? 'date' : 'datetime'"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column title="到达地" width="90">
          <template v-slot="{ row }">
            <vxe-input v-model="row.endPlace" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column> -->
        <!-- <vxe-table-column field="endPlaceArea" title="到达地" width="200">
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.endPlaceArea"
              placeholder="到达地"
              @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column> -->
        <vxe-table-column field="endProvince" title="到达地(省)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endProvince"
                :options="cityData"
                @change="loadCity(row.endProvince, $rowIndex, 2)"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endCity" title="到达地(市)" width="100">
          <template v-slot="{ row, $rowIndex }">
            <vxe-select
                v-model="row.endCity"
                :options="row.endCityOptions"
                @change="loadArea(row.endProvince, row.endCity, $rowIndex, 2)"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endArea" title="到达地(区)" width="100">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.endArea"
                :options="row.endAreaOptions"
                @blur="clearTableV"
                :disabled="row.contractBusType !== 2"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endPlaceAddress" title="详细地址" width="160">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.endPlaceAddress"
                placeholder="到达地"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="endTime" title="到达时间" width="160">
          <template v-slot="{ row }">
            <!-- <vxe-input v-model="row.endTime" placeholder="选填"></vxe-input> -->
            <vxe-input
                v-model="row.endTime"
                placeholder="选择日期"
                @blur="clearTableV"
                :type="row.contractBusType === 1 ? 'date' : 'datetime'"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverName" title="司机" width="140">
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                @click="openDriver($rowIndex)"
                v-if="row.contractBusType === 2"
                target="_black"
            >{{
              row.driverName === null || row.driverName === ""
              ? "请选择司机"
              : row.driverName
              }}</a
            >
          </template>
        </vxe-table-column>
        <vxe-table-column field="driverPhone" title="手机号" width="120">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.driverPhone"
                v-if="row.contractBusType === 2"
                readonly
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="生成电子合同" width="120">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.isNeedContractImg"
                placeholder="请选择"
                @blur="clearTableV"
                @change="contractBusChange"
                :options="contractImgType"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column title="收款人" width="100" field="collectionName">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.collectionName"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="开户行" width="150" field="collectionBank">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.collectionBank"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
            title="银行账户"
            width="200"
            field="collectionAccount"
        >
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.collectionAccount"
                placeholder="选填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="prepayment" title="定金" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.prepayment"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="demurrageAmount" title="滞期费" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.demurrageAmount"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="loadDay" title="装卸天数" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.loadDay"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="payWay" title="付款方式" width="115">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.payWay"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="deliveryWay"
            title="计量及交接方式"
            width="115"
        >
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.deliveryWay"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="specificClauseExtra"
            title="补充约定"
            width="115"
        >
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.specificClauseExtra"
                placeholder="选填"
                v-if="row.contractBusType === 1"
            ></vxe-input>
          </template>
        </vxe-table-column>

        <vxe-table-column field="fileAddUrlList" title="上传附件" width="75">
          <template v-slot="{ row, $rowIndex }">
            <div
                v-if="
                row.fileAddUrlList == undefined ||
                  row.fileAddUrlList.length <= 0
              "
                class="file-upload-box"
                @click="
                addFile({ i: $rowIndex, data: formData, key: 'fileAddUrlList' })
              "
            >
              <Icon type="md-add" size="20"></Icon>
            </div>
            <div
                v-if="row.fileAddUrlList.length > 0"
                class="file-upload-box"
                @click="
                addFile({ i: $rowIndex, data: formData, key: 'fileAddUrlList' })
              "
            >
              <span>更多</span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ifGenerate" title="生成物流及结算" width="120">
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.ifGenerate"
                placeholder="请选择"
                :options="contractImgType"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNum" title="物流单号" width="150">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.logisticsNum"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isTop" title="状态" width="120">
          <template v-slot="scope">
            <vxe-select
                v-model="scope.row.isTop"
                placeholder="请选择"
                :options="isTopTypeOptions"
                @focus="clearTableV"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="goodsCounts" title="装货数量" width="100">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.goodsCounts"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="realCount" title="实际数量" width="100">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.realCount"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="logisticsNote" title="物流备注" width="150">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.logisticsNote"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiveGoodsTime" title="结算时间" width="120">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.receiveGoodsTime"
                placeholder="选择日期"
                @change="clearTableV"
                type="date"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="settleAmount" title="结算金额" width="100">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.settleAmount"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="receiveGoodsNote" title="结算摘要" width="150">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.receiveGoodsNote"
                placeholder="选填"
                @focus="clearTableV"
            ></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent">上传导入文件</Button>
      <Button status="primary" @click="commit">提 交</Button>
    </div>
    <vxe-modal
        v-model="isShowModal"
        title="选择账户"
        width="800"
        height="600"
        resize
    >
      <account-modal @choose="chooseUser" ref="userModel"></account-modal>
    </vxe-modal>
    <vxe-modal
        v-model="contractVisible"
        title="选择合同"
        width="1300"
        height="700"
        resize
        remember
    >
      <contract-modal
          @choose="chooseContract"
          ref="contractModel"
      ></contract-modal>
    </vxe-modal>
    <vxe-modal
        v-model="orderVisible"
        title="选择订单"
        width="1300"
        height="700"
        resize
        remember
    >
      <order-modal @choose="chooseOrder" ref="orderModel"></order-modal>
    </vxe-modal>
    <vxe-modal
        v-model="carShipVisible"
        title="选择车船"
        width="1300"
        height="600"
        resize
        remember
    >
      <choose-car-ship
          ref="carShipModal"
          @choose="chooseCarShip"
      ></choose-car-ship>
    </vxe-modal>
    <vxe-modal
        v-model="fileVisible"
        title="附件上传"
        width="600"
        height="600"
        resize
        remember
    >
      <upload-img
          ref="uploadImg"
          @fileList="getFileList"
          :viewType="true"
      ></upload-img>
    </vxe-modal>
    <vxe-modal
        v-model="driverModal"
        title="选择司机"
        width="800"
        height="600"
        resize
    >
      <driver-modal @choose="chooseDriver" ref="driverModel"></driver-modal>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="600"
        height="350"
        @close="closeMessage"
        remember
    >
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import LogoVue from "../common/Logo.vue";

  import $C from "@/consts/index";
  import $api from "@/apiProvider";
  import PlatformCorp from "@/components/common/PlatformCorp";
  import SalesMan from "@/components/common/SalesMan";
  import auth from "@/utils/auth";
  import AccountModal from "@/components/modal/Account"; // 选择账户弹窗
  import ContractModal from "@/components/modal/ChooseContract"; //选择合同
  import OrderModal from "@/components/modal/ChooseOrder"; //选择订单
  import ChooseCarShip from "@/components/modal/ChooseCarShip";
  import Viewer from "viewerjs";
  import {
    getExcelTime,
    showLoading,
    hideLoading,
    isNotEmpty,
    isEmpty
  } from "@/utils/util";
  import XLSX from "xlsx";
  import Message from "@/components/common/Message";
  import UploadImg from "@/components/modal/UploadImg";
  import DriverModal from "@/components/modal/ChooseDriver"; // 选择司机弹窗
  import "viewerjs/dist/viewer.css";
  import {contractbusMap, taxMap} from "@/filters/type";
  import {timeFormatDate, timeToVal} from "@/filters/time";

  const empties = [undefined, "", null, "null", {}, []];
  import moment from "moment";

  var appData = require("@/assets/json/zz.json");

  export default {
    props: {
      type: Number,
      rowInfo: Object,
      isShowAddModal: Boolean
    },
    components: {
      AccountModal,
      ContractModal,
      OrderModal,
      ChooseCarShip,
      UploadImg,
      Message,
      PlatformCorp,
      SalesMan,
      DriverModal
    },
    data() {
      return {
        fileVisible: false,
        messageVisible: false,
        saleMap: new Map(),

        formData: [
          {
            no: 1,
            salesManNameXs: null,
            salesManName: null,
            buyerOrdersNum: null,
            buyerOrderId: null,
            contractNum: null,
            contractId: null,
            contractTitle: null,
            contractBusType: null,
            addTime: null,
            buyerName: null,
            sellerName: null,
            amount: null,
            buyerAmount: null,
            goodsName: null,
            goodsType: null,
            rule: null, // 规格
            packUnit: null,
            unit: null, // 单位
            counts: null, // 数量
            price: null, // 单价
            priceType: null,
            isTax: null, // 是否含税
            carShipNum: null, // 车船号
            transportationType: null,
            deliveryPoints: null, // 交货地点
            beginPlace: null, // 起运地
            endPlace: null, // 到达地
            beginPlaceArea: [],
            beginPlaceAddress: null,
            endPlaceArea: [],
            endPlaceAddress: null,
            beginTime: null, // 交接受载期
            prepayment: null,
            isNeedContractImg: null,
            demurrageAmount: null,
            loadDay: null,
            payWay: null,
            deliveryWay: null,
            specificClauseExtra: null,
            fileAddUuidList: [],
            fileAddUrlList: [],
            fileUuidList: [],
            addWay: 1,
            driverId: null,
            driverName: null,
            driverPhone: null,
            collectionName: null,
            collectionBank: null,
            collectionAccount: null,
            ifGenerate: null, // 是否生成物流及结算
            logisticsNum: null, // 物流单号
            isTop: null,
            goodsCounts: null, // 装货数量
            realCount: null, // 实际数量
            logisticsNote: null, // 物流备注
            receiveGoodsTime: null, // 结算时间
            settleAmount: null, // 结算金额
            receiveGoodsNote: null, // 结算摘要
            province: null,
            city: null,
            area: null,
            endProvince: null,
            endCity: null,
            endArea: null,
            cityOptions: [],
            endCityOptions: []
          }
        ],
        orderInfo: {},
        contractInfo: {},
        validRules: {
          // amountTotal: [{ type: "number", message: "输入金额必须为数字" }],
          // goodsName: [{ required: true, message: "货名不能为空" }],
          // unit: [{ required: true, message: "单位不能为空" }],
          salesManName: [{required: true, message: "业务员不能为空"}],
          // transportationType: [{ required: true, message: "货运类型不能为空" }],
          contractBusType: [{required: true, message: "类别不能为空"}],
          // counts: [
          //   {
          //     required: true,
          //     type: "number",
          //     message: "数量不能为空且必须为数字",
          //   },
          // ],
          // addTime: [{ required: true, message: "签约时间不能为空" }],
          buyerName: [{required: true, message: "托运人名称不能为空"}],
          sellerName: [{required: true, message: "承运人名称不能为空"}],
          goodsName: [{validator: this.requireValid}],
          goodsType: [{validator: this.requireValid}],
          unit: [{validator: this.requireValid}],
          counts: [{validator: this.requireValid}],
          priceType: [{validator: this.requireValid}],
          isTax: [{validator: this.requireValid}],
          carShipNum: [{validator: this.requireValid}],
          // beginPlace: [{ validator: this.requireValid }],
          // endPlace: [{ validator: this.requireValid }],
          beginPlaceAddress: [{validator: this.requireValid}],
          endPlaceAddress: [{validator: this.requireValid}],
          province: [{validator: this.requireValid}],
          city: [{validator: this.requireValid}],
          area: [{validator: this.requireValid}],
          endProvince: [{validator: this.requireValid}],
          endCity: [{validator: this.requireValid}],
          endArea: [{validator: this.requireValid}],
          beginTime: [{validator: this.requireValid}],
          price: [
            {
              validator: this.requireValid
            }
          ],
          endTime: [
            {
              validator: this.requireValid
            }
          ],
          amount: [
            {
              validator: this.requireValid
            }
          ],
          buyerAmount: [
            {
              validator: this.requireValid
            }
          ],
          goodsCounts: [
            {
              validator: this.requireValid
            }
          ],
          realCount: [
            {
              validator: this.requireValid
            }
          ],
          receiveGoodsTime: [
            {
              validator: this.requireValid
            }
          ],
          settleAmount: [
            {
              validator: this.requireValid
            }
          ]
          // price: [{ type: "number", message: "输入金额必须为数字" }],
          // isTax: [{ required: true, message: "请选择是否含税" }],
        },
        uploadData: [
          {
            url: ""
          }
        ],
        uploadList: [],
        contractListType: $C.CONTRACTBUS_TYPE.options, // 业务类型选择框
        taxType: $C.TAX_TYPE.options, // 是否含税类型选择框
        transportationType: $C.TRANSPORTAION_TYPE.options,
        contractImgType: $C.CONTRACT_IMG_TYPE.options,
        priceType: $C.PRICE_TYPE.options,
        url: "",
        buyerNameIndex: null,
        visible: false,
        file: null, // 上传
        imgUrl: null,
        orderPicUUID: [],
        chainIdColumn: [{field: "chainNum", title: "主订单编号"}], // 关联主订单下拉框数据列
        dicByParentData: [],
        dicByParentColumn: [{field: "dictText", title: "企业名称"}], // 选择平台企业下拉框数据列
        loading: false,
        chainIdData: [], // 关联主订单数据
        chainIdPage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini"
        }, // 关联主订单分页
        filterChainId: null, // 关联主订单搜索
        filterSellerName: null, // 承运人订单搜索
        contractVisible: false, // 是否显示选择合同弹窗
        isShowModal: false, // 是否显示选择用户账户弹窗
        orderVisible: false, // 是否显示选择订单
        carShipVisible: false, // 是否显示车船号弹窗
        carShipInfo: null,
        uploadHeaders: {
          Authorization: auth.getAuth().token,
          token: auth.getAuth().token
        },
        viewer: null,
        usedType: 2, // 1-合同,2-托运人订单,3-承运人订单,4-实际承运人订单
        isSuccess: false,
        // chainObj: {
        //   chainId: null,
        //   chainNum: null,
        // },
        addFileInfo: null, // 存储点击事件
        driverIndex: "",
        driverModal: false,
        goodsTypeOptions: [],
        unitTypeOptions: [],
        cityData: [],
        isTopTypeOptions: $C.LogisticsIsTopStatus.options
      };
    },
    computed: {},
    watch: {},
    mounted() {
      // this.getDicByParentList();
      this.querySalesList();
      this.getDicContractBusType();
    },
    methods: {
      getDicContractBusType() {
        this.contractListType = [];
        this.goodsTypeOptions = [];
        this.unitTypeOptions = [];
        $api.other.getContractBusTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              var obj = {
                label: item.dictText,
                value: parseInt(item.note)
              };
              this.contractListType.push(obj);
            });
          });
        $api.other.getGoodsTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              var obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.goodsTypeOptions.push(obj);
            });
          });
        $api.other.getUnitTypeModel
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              var obj = {
                label: item.dictText,
                value: item.dictText
              };
              this.unitTypeOptions.push(obj);
            });
          });

        appData.forEach(item => {
          let obj = {
            value: item.label,
            label: item.label
          };
          this.cityData.push(obj);
        });
      },
      loadCity(province, index, type, isImpot = false) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].city = "";
            tableData[index].area = "";
          } else {
            tableData[index].endCity = "";
            tableData[index].endArea = "";
          }
        }

        let cityOptions = appData.filter(i => i.label === province);
        let isHasChildren = cityOptions[0].children.some(m =>
          isNotEmpty(m.children)
        );
        if (isHasChildren) {
          let arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
          type === 1
            ? (tableData[index].cityOptions = arr)
            : (tableData[index].endCityOptions = arr);
        } else {
          let cityArr = [
            {
              label: province,
              value: province
            }
          ];
          type === 1
            ? (tableData[index].cityOptions = cityArr)
            : (tableData[index].endCityOptions = cityArr);
        }
      },
      loadArea(province, city, index, type, isImpot = false) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        if (!isImpot) {
          if (type === 1) {
            tableData[index].area = "";
          } else {
            tableData[index].endArea = "";
          }
        }
        let cityOptions = appData.filter(i => i.label === province);
        let arr = [];
        if (province === city) {
          arr = cityOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        } else {
          let areaOptions = cityOptions[0].children.filter(i => i.label === city);
          arr = areaOptions[0].children.map(i => {
            return {
              label: i.label,
              value: i.label
            };
          });
        }
        type === 1
          ? (tableData[index].areaOptions = arr)
          : (tableData[index].endAreaOptions = arr);
      },
      loadData(item, callback) {
        const getTree = jsonObj => {
          function toParse(jsonObj) {
            jsonObj.forEach(item => {
              item.value = item.label;
              if (item.children && Array.isArray(item.children)) {
                toParse(item.children);
              }
            });
            return jsonObj;
          }

          return toParse(jsonObj);
        };
        var curCityData = getTree(appData);
        item.loading = true;
        setTimeout(() => {
          let arr = curCityData.filter(i => {
            return i.label === item.value;
          });
          item.children = arr[0].children;
          item.loading = false;
          callback();
        }, 1000);
      },
      openDriver(index) {
        this.driverModal = true;
        this.driverIndex = index;
        this.clearTableV();
        this.$refs.driverModel.init();
      },
      chooseDriver(row) {
        let tableData = this.$refs.xTable.getTableData().tableData;
        if (row.phoneNum) {
          tableData[this.driverIndex].driverId = row.id;
          tableData[this.driverIndex].driverName = row.realName;
          tableData[this.driverIndex].driverPhone = row.phoneNum;
        } else {
          tableData[this.driverIndex].driverId = null;
          tableData[this.driverIndex].driverName = null;
          tableData[this.driverIndex].driverPhone = null;
          this.$XModal.alert({
            message: "请先维护该司机信息",
            status: "error"
          });
        }
        this.driverModal = false;
      },
      closeMessage() {
        this.messageVisible = false;
      },
      clearValidate(tableName) {
        let table = this.$refs[tableName];
        table.clearValidate();
      },
      reset() {
        this.formData = [
          {
            buyerOrdersNum: null,
            contractNum: null,
            contractId: null,
            contractTitle: null,
            salesManNameXs: null,
            salesManName: null,
            contractBusType: null,
            addTime: null,
            buyerName: null,
            sellerName: null,
            amount: null,
            buyerAmount: null,
            goodsName: null,
            goodsType: null,
            rule: null, // 规格
            packUnit: null,
            unit: null, // 单位
            counts: null, // 数量
            price: null, // 单价
            priceType: null,
            isTax: null, // 是否含税
            carShipNum: null, // 车船号
            transportationType: null,
            // deliveryPoints: null, // 交货地点
            beginPlace: null, // 起运地
            endPlace: null, // 到达地
            beginPlaceArea: [],
            beginPlaceAddress: null,
            endPlaceArea: [],
            endPlaceAddress: null,
            beginTime: null, // 交接受载期
            endTime: null,
            prepayment: null,
            isNeedContractImg: null,
            demurrageAmount: null,
            loadDay: null,
            payWay: null,
            deliveryWay: null,
            specificClauseExtra: null,
            fileAddUuidList: [],
            fileAddUrlList: [],
            fileUuidList: [],
            addWay: 1,
            driverId: null,
            driverName: null,
            driverPhone: null,
            collectionName: null,
            collectionBank: null,
            collectionAccount: null,
            ifGenerate: null, // 是否生成物流及结算
            logisticsNum: null, // 物流单号
            goodsCounts: null, // 装货数量
            realCount: null, // 实际数量
            logisticsNote: null, // 物流备注
            receiveGoodsTime: null, // 结算时间
            settleAmount: null, // 结算金额
            receiveGoodsNote: null, // 结算摘要
            province: null,
            city: null,
            area: null,
            endProvince: null,
            endCity: null,
            endArea: null,
            cityOptions: [],
            endCityOptions: []
          }
        ];
      },

      async insertEvent(row) {
        let record = {
          no: this.$refs.xTable.data.length + 1,
          buyerOrdersNum: null,
          contractNum: null,
          contractId: null,
          contractTitle: null,
          contractBusType: null,
          salesManName: null,
          salesManNameXs: null,
          addTime: null,
          buyerName: null,
          sellerName: null,
          amount: null,
          buyerAmount: null,
          goodsName: null,
          goodsType: null,
          rule: null, // 规格
          packUnit: null,
          unit: null, // 单位
          counts: null, // 数量
          price: null, // 单价
          priceType: null,
          isTax: null, // 是否含税
          carShipNum: null, // 车船号
          transportationType: null,
          // deliveryPoints: null, // 交货地点
          beginPlace: null, // 起运地
          endPlace: null, // 到达地
          beginPlaceArea: [],
          beginPlaceAddress: null,
          endPlaceArea: [],
          endPlaceAddress: null,
          beginTime: null, // 交接受载期
          endTime: null,
          fileAddUuidList: [],
          fileAddUrlList: [],
          fileUuidList: [],
          addWay: 1,
          driverId: null,
          driverName: null,
          driverPhone: null,
          collectionName: null,
          collectionBank: null,
          collectionAccount: null,
          ifGenerate: null, // 是否生成物流及结算
          logisticsNum: null, // 物流单号
          isTop: null,
          goodsCounts: null, // 装货数量
          realCount: null, // 实际数量
          logisticsNote: null, // 物流备注
          receiveGoodsTime: null, // 结算时间
          settleAmount: null, // 结算金额
          receiveGoodsNote: null, // 结算摘要
          province: null,
          city: null,
          area: null,
          endProvince: null,
          endCity: null,
          endArea: null,
          cityOptions: [],
          endCityOptions: []
        };

        let {row: newRow} = await this.$refs.xTable.insertAt(record, row);
        this.$refs.xTable.data.push(record);
        // await this.$refs.xTable.setActiveCell(newRow, "ordersBuyerId");
        // console.log(this.$refs.xTable.getformData().fullData);
      },
      async requireValid(e) {
        if (e.column.title == "托运人金额" && !isEmpty(e.row.buyerAmount)) {
          let arr = e.row.buyerAmount.toString().split(".")[1];
          if (arr && arr.length > 2) {
            return Promise.reject(
              new Error("托运人金额最多只能输入小数点后两位")
            );
          }
        }
        if (e.row.isNeedContractImg === 1 || e.row.ifGenerate === 1) {
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "托运人金额" &&
            isEmpty(e.row.buyerAmount)
          ) {
            return Promise.reject(new Error("请填写托运人金额"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "起运地(省)" &&
            isEmpty(e.row.province)
          ) {
            return Promise.reject(new Error("请选择起运地省"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "起运地(市)" &&
            isEmpty(e.row.city)
          ) {
            return Promise.reject(new Error("请选择起运地市"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "起运地(区)" &&
            isEmpty(e.row.area)
          ) {
            return Promise.reject(new Error("请选择起运地区"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "到达地(省)" &&
            isEmpty(e.row.endProvince)
          ) {
            return Promise.reject(new Error("请选择到达地省"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "到达地(市)" &&
            isEmpty(e.row.endCity)
          ) {
            return Promise.reject(new Error("请选择到达地市"));
          }
          if (
            e.row.contractBusType === 2 &&
            e.column.title == "到达地(区)" &&
            isEmpty(e.row.endArea)
          ) {
            return Promise.reject(new Error("请选择到达地区"));
          }
          // if (
          //   e.row.contractBusType === 2 &&
          //   e.column.title == "到达时间" &&
          //   isEmpty(e.row.endTime)
          // ) {
          //   return Promise.reject(new Error("到达时间不能为空"));
          // }
          if (
            e.row.priceType === 1 &&
            isEmpty(e.row.price) &&
            e.column.title == "单价"
          ) {
            return Promise.reject(new Error("单价不能为空"));
          }
          if (
            (e.row.priceType === 2 || e.row.priceType === 3) &&
            isEmpty(e.row.amount) &&
            e.column.title == "总金额"
          ) {
            return Promise.reject(new Error("总金额不能为空"));
          }
          if (
            e.row.ifGenerate === 1 &&
            isEmpty(e.row.goodsCounts) &&
            e.column.title == "装货数量"
          ) {
            return Promise.reject(new Error("请填写装货数量"));
          }
          if (
            e.row.ifGenerate === 1 &&
            isEmpty(e.row.realCount) &&
            e.column.title == "实际数量"
          ) {
            return Promise.reject(new Error("请填写实际数量"));
          }
          if (
            e.row.ifGenerate === 1 &&
            isEmpty(e.row.receiveGoodsTime) &&
            e.column.title == "结算时间"
          ) {
            return Promise.reject(new Error("请填写结算时间"));
          }
          if (
            e.row.ifGenerate === 1 &&
            isEmpty(e.row.settleAmount) &&
            e.column.title == "结算金额"
          ) {
            return Promise.reject(new Error("请填写结算金额"));
          }
          if (
            empties.includes(e.cellValue) &&
            ![
              "单价",
              "总金额",
              "装货数量",
              "实际数量",
              "结算时间",
              "结算金额",
              "托运人金额",
              "起运地(省)",
              "起运地(市)",
              "起运地(区)",
              "到达地(省)",
              "到达地(市)",
              "到达地(区)"
            ].includes(e.column.title)
          ) {
            return Promise.reject(new Error(e.column.title + "必填"));
          }
        }
      },
      async validEvent() {
        let errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
        return errMap ? false : true;
      },
      async commit() {
        var self = this;
        var data = [];
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }
        self.formData.forEach(function (item, index) {
          let obj = {};
          let beginPlaceArea = isNotEmpty(item.area)
            ? item.province === item.city
              ? `${item.city},${item.area}`
              : `${item.province},${item.city},${item.area}`
            : "";
          let beginPlaceArea2 = isNotEmpty(item.area)
            ? item.province === item.city
              ? `${item.city}${item.area}`
              : `${item.province}${item.city}${item.area}`
            : "";

          let endPlaceArea = isNotEmpty(item.endArea)
            ? item.endProvince === item.endCity
              ? `${item.endCity},${item.endArea}`
              : `${item.endProvince},${item.endCity},${item.endArea}`
            : "";
          let endPlaceArea2 = isNotEmpty(item.endArea)
            ? item.endProvince === item.endCity
              ? `${item.endCity}${item.endArea}`
              : `${item.endProvince}${item.endCity}${item.endArea}`
            : "";
          // let beginPlaceArea = isNotEmpty(item.beginPlaceArea)
          //   ? item.beginPlaceArea.join(",")
          //   : "";
          // let beginPlaceArea2 = isNotEmpty(item.beginPlaceArea)
          //   ? item.beginPlaceArea.join("")
          //   : "";
          // let endPlaceArea = isNotEmpty(item.endPlaceArea)
          //   ? item.endPlaceArea.join(",")
          //   : "";
          // let endPlaceArea2 = isNotEmpty(item.endPlaceArea)
          //   ? item.endPlaceArea.join("")
          //   : "";
          let beginPlaceAddress = isNotEmpty(item.beginPlaceAddress)
            ? item.beginPlaceAddress
            : "";
          let endPlaceAddress = isNotEmpty(item.endPlaceAddress)
            ? item.endPlaceAddress
            : "";
          let beginPlace = beginPlaceArea2 + beginPlaceAddress;
          let endPlace = endPlaceArea2 + endPlaceAddress;
          obj.goods = [
            {
              addTime: null,
              goodsName: null,
              goodsType: null,
              rule: null,
              packUnit: null,
              unit: null,
              counts: null,
              price: null,
              amount: null,
              buyerAmount: null,
              priceType: null,
              isTax: null,
              carShipNum: null,
              transportationType: null,
              // deliveryPoints: null,
              beginPlace: null,
              endPlace: null,
              beginPlaceArea: [],
              beginPlaceAddress: null,
              endPlaceArea: [],
              endPlaceAddress: null,
              beginTime: null,
              endTime: null,
              driverId: null,
              driverName: null,
              driverPhone: null,
              prepayment: null,
              demurrageAmount: null,
              loadDay: null,
              payWay: null,
              deliveryWay: null,
              specificClauseExtra: null,
              orderPicUUID: [],
              ifGenerate: null, // 是否生成物流及结算
              logisticsNum: null, // 物流单号
              goodsCounts: null, // 装货数量
              realCount: null, // 实际数量
              logisticsNote: null, // 物流备注
              receiveGoodsTime: null, // 结算时间
              settleAmount: null, // 结算金额
              receiveGoodsNote: null, // 结算摘要
              isTop: null
            }
          ];
          if (item.addTime) {
            obj.goods[0].addTime = self.$utils.timestamp(item.addTime);
          }
          obj.index = item.index;
          obj.buyerOrdersNum = item.buyerOrdersNum;
          obj.contractNum = item.contractNum;
          obj.contractTitle = item.contractTitle;
          obj.contractId = item.contractId;
          obj.salesManName = item.salesManName;
          obj.salesManagerName = item.salesManNameXs;
          obj.contractBusType = item.contractBusType;
          obj.buyerName = item.buyerName;
          obj.sellerName = item.sellerName;
          // obj.amountTotal = item.amountTotal;
          // obj.isNeedContractImg = item.isNeedContractImg;
          if (item.isNeedContractImg == "是") {
            obj.goods[0].isNeedContractImg = 1;
          } else if (item.isNeedContractImg == "否") {
            obj.goods[0].isNeedContractImg = 0;
          }
          obj.goods[0].prepayment = item.prepayment;
          obj.goods[0].demurrageAmount = item.demurrageAmount;
          obj.goods[0].loadDay = item.loadDay;
          obj.goods[0].payWay = item.payWay;
          obj.goods[0].deliveryWay = item.deliveryWay;
          obj.goods[0].specificClauseExtra = item.specificClauseExtra;
          obj.isSecondSeller = 0;
          obj.no = item.no;
          // obj.goods[0].addTime = item.addTime;
          obj.goods[0].amount = item.amount;
          obj.goods[0].buyerAmount = item.buyerAmount;
          obj.goods[0].goodsName = item.goodsName;
          obj.goods[0].goodsType = item.goodsType;
          obj.goods[0].rule = item.rule; // 规格
          obj.goods[0].packUnit = item.packUnit;
          obj.goods[0].unit = item.unit; // 单位
          obj.goods[0].counts = item.counts; // 数量
          obj.goods[0].price = item.price; // 单价
          obj.goods[0].priceType = item.priceType;
          obj.goods[0].isTax = item.isTax; // 是否含税
          obj.goods[0].transportationType = item.transportationType;
          if (item.isTax == "是") {
            obj.goods[0].isTax = 1;
          } else if (item.isTax == "否") {
            obj.goods[0].isTax = 0;
          }
          if (item.priceType == "单价") {
            obj.goods[0].priceType = 1;
          } else if (item.priceType == "包车") {
            obj.goods[0].priceType = 2;
          } else if (item.priceType == "包船") {
            obj.goods[0].priceType = 3;
          }
          if (item.transportationType == "车辆") {
            obj.goods[0].transportationType = 1;
          } else if (item.transportationType == "船舶") {
            obj.goods[0].transportationType = 2;
          }
          if (item.contractBusType == 2) {
            obj.goods[0].prepayment = null;
            obj.goods[0].demurrageAmount = null;
            obj.goods[0].loadDay = null;
            obj.goods[0].payWay = null;
            obj.goods[0].deliveryWay = null;
            obj.goods[0].specificClauseExtra = null;
          }
          obj.goods[0].carShipNum = item.carShipNum; // 车船号
          // obj.goods[0].deliveryPoints = item.deliveryPoints; // 交货地点
          // obj.goods[0].beginPlace = item.beginPlace; // 起运地
          // obj.goods[0].endPlace = item.endPlace; // 到达地
          obj.goods[0].beginPlace = beginPlace; // 起运地
          obj.goods[0].endPlace = endPlace; // 到达地
          obj.goods[0].beginPlaceArea = beginPlaceArea;
          obj.goods[0].beginPlaceAddress = beginPlaceAddress;
          obj.goods[0].endPlaceArea = endPlaceArea;
          obj.goods[0].endPlaceAddress = endPlaceAddress;
          if (item.beginTime && item.beginTime !== '') {
            obj.goods[0].beginTime = self.$utils.timestamp(item.beginTime);
          }
          // obj.goods[0].beginTime = self.$utils.timestamp(item.beginTime); // 交接受载期
          if (item.endTime && item.endTime !== '') {
            obj.goods[0].endTime = self.$utils.timestamp(item.endTime);
          }
          // obj.goods[0].endTime = self.$utils.timestamp(item.endTime);
          obj.goods[0].driverId = item.driverId;
          obj.goods[0].driverName = item.driverName;
          obj.goods[0].driverPhone = item.driverPhone;
          obj.goods[0].collectionName = item.collectionName;
          obj.goods[0].collectionBank = item.collectionBank;
          obj.goods[0].collectionAccount = item.collectionAccount;
          // obj.goods[0].beginTime = self.$utils.timestamp(item.beginTime); // 交接受载期
          obj.addWay = 1;
          item.fileAddUrlList.forEach(function (item2, index2) {
            obj.goods[0].orderPicUUID.push(item2.uuid);
          });
          // if (item.ifGenerate == "是") {
          //   obj.goods[0].ifGenerate = 1;
          // } else if (item.ifGenerate == "否") {
          //   obj.goods[0].ifGenerate = 0;
          // }
          obj.goods[0].ifGenerate = item.ifGenerate;
          obj.goods[0].logisticsNum = item.logisticsNum;
          obj.goods[0].goodsCounts = item.goodsCounts;
          obj.goods[0].realCount = item.realCount;
          obj.goods[0].logisticsNote = item.logisticsNote;
          obj.goods[0].receiveGoodsTime = self.$utils.timestamp(
            item.receiveGoodsTime
          );
          obj.goods[0].settleAmount = item.settleAmount;
          obj.goods[0].receiveGoodsNote = item.receiveGoodsNote;
          obj.goods[0].isTop = item.isTop;
          // obj.fileUuidList = item.fileAddUuidList;
          data.push(obj);
        });
        // data = {
        //   data,
        // };
        // 判断商品明细货运类型是否跟业务类型一致
        let isCanNotSubmit = data.some(i => {
          if (i.goods[0]) {
            if (
              i.goods[0].beginTime &&
              i.goods[0].endTime &&
              i.goods[0].beginTime > i.goods[0].endTime
            ) {
              let msg = `第${i.index}行，到达时间不能早于受载/起运时间`;
              this.$XModal.alert({
                message: msg,
                status: "error"
              });
              return true;
            }
            let boolenArr = [];
            boolenArr.push(
              isNotEmpty(i.goods[0].collectionName),
              isNotEmpty(i.goods[0].collectionBank),
              isNotEmpty(i.goods[0].collectionAccount)
            );
            let isboolenArr = [...new Set(boolenArr)];
            if (isboolenArr.length > 1) {
              let msg = `第${i.index}行，收款人、开户行、银行账户字段，必须全为空或全不为空`;
              this.$XModal.alert({
                message: msg,
                status: "error"
              });
              return true;
            }
          }
          if (
            (i.contractBusType === 1 && i.goods[0].transportationType === 1) ||
            (i.contractBusType === 2 && i.goods[0].transportationType === 2)
          ) {
            let msg = `第${i.index}行，业务类型与货运类型不匹配`;
            this.$XModal.alert({
              message: msg,
              status: "error"
            });
            return true;
          }
        });
        if (isCanNotSubmit) {
          return;
        }
        showLoading();
        let res = await $api.sellerOrder
          .request("batchCreateOrdersSeller", data)
          .then(res => {
            hideLoading();
            if (res.status == 1) {
              this.$Spin.hide();
              this.$Message["success"]({
                background: true,
                content: "创建成功"
              });
              this.reset();
              this.$emit("createCommit", false);
            } else {
              let message = "";
              let message2 = "";
              var messageMap = new Map();
              if (res.data && res.data.length > 0) {
                let failArrayList = [];
                res.data.map(i => {
                  failArrayList.push(i.failArrayIndex);
                  messageMap.set(i.failArrayIndex, i.failMsg);
                  message =
                    message +
                    "第" +
                    (i.failArrayIndex + 1) +
                    "行，" +
                    i.failMsg +
                    "\n";
                });
                if (failArrayList.length > 0) {
                  let newTableData = [];
                  self.formData.forEach((item, index) => {
                    if (failArrayList.includes(index)) {
                      newTableData.push(item);
                      message2 =
                        message2 +
                        "序号" +
                        item.no +
                        "，" +
                        messageMap.get(index) +
                        "\n";
                    }
                  });
                  self.formData = newTableData;
                }
              }
              if (message == "") {
                if (res.message != null) {
                  this.$XModal.alert({
                    message: res.message,
                    status: "error"
                  });
                } else {
                  this.$XModal.alert({
                    message: "接口异常",
                    status: "error"
                  });
                }
              } else {
                message = message2;
                this.$refs.messageModal.setMessage(message);
                this.messageVisible = true;
              }
            }
          })
          .catch(function (er) {
            hideLoading();
            console.log(er);
            if (er.response == undefined) {
              self.$XModal.alert({
                message:
                  "接口超时，请3分钟后再确认数据是否导入成功，请勿重复提交",
                status: "error"
              });
            } else {
              self.$XModal.alert({
                message: er.response.data.message
                  ? er.response.data.message
                  : "接口异常",
                status: "error"
              });
            }
            return;
          });
      },
      removeEvent(row, i) {
        this.$refs.xTable.remove(row);
        this.$refs.xTable.data.splice(i, 1);
      },
      addFile(obj) {
        this.addFileInfo = obj;
        let data = this.addFileInfo.data;
        let i = this.addFileInfo.i;
        this.uploadList = data[i]["fileAddUrlList"];
        // this.addUuidList = data[i]["fileAddUuidList"];
        console.log("xxxx");
        this.$refs.uploadImg.setList(this.uploadList);
        this.fileVisible = true;
      },
      getFileList(row) {
        console.log(row);
        let data = this.addFileInfo.data;
        let i = this.addFileInfo.i;
        data[i]["fileAddUrlList"] = row;
        // (data[i]["fileAddNameList"] = row.addUrlList.name),
        //   (data[i]["fileAddUuidList"] = row.addUuidList);
        // data[i]["fileAddUrlList"] = row.addUrlList.url;
      },
      //选择合同
      openContract(obj) {
        this.contractInfo = obj;
        this.contractVisible = true;
        this.$refs.contractModel.init(2);
      },
      //选择订单
      openOrder(obj) {
        this.orderInfo = obj;
        this.orderVisible = true;
        this.$refs.orderModel.init(1);
      },
      //选择合同返回
      chooseContract(row) {
        let data = this.contractInfo.data;
        let i = this.contractInfo.i;
        this.formData[i]["contractId"] = row.id;
        this.formData[i]["contractNum"] = row.numb;
        this.formData[i]["contractTitle"] = row.title;
        this.formData[i]["addTime"] = row.addTime;
        this.formData[i]["addWay"] = row.addWay;

        // this.formData[i]["amountTotal"] = row.amountTotal;
        this.formData[i]["buyerName"] = row.buyerName;
        this.formData[i]["sellerName"] = row.sellerName;
        this.formData[i]["contractBusType"] = row.busType;
        // this.newGoodsArr = row.goodsList;
        this.contractVisible = false;
      },
      //选择订单
      chooseOrder(row) {
        this.clearTableV();
        // console.log(row, '11111111111123')
        let data = this.orderInfo.data;
        let i = this.orderInfo.i;
        this.formData[i]["buyerOrdersNum"] = row.buyerOrdersNum;
        // this.formData[i]["buyerOrderId"] = row.id;
        // this.chainObj.chainId = row.chainId;
        // this.chainObj.chainNum = row.chainNum;
        this.orderVisible = false;
      },
      openUser(obj) {
        this.orderInfo = obj;

        this.isShowModal = true;
        this.$refs.userModel.init(1);
      },
      chooseUser(row, type) {
        this.clearTableV();
        let data = this.orderInfo.data;
        let i = this.orderInfo.i;
        this.formData[i]["sellerName"] = row.userName;
        this.isShowModal = false;
      },
      openCarShip(obj) {
        this.carShipInfo = obj;
        this.carShipVisible = true;
        this.$refs.carShipModal.init();
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
        console.log("blur事件被执行了");
      },
      inputcounts(row) {
        if (row.counts) {
          if (row.price) {
            row.amount = Math.round(row.counts * row.price * 100) / 100;
          }
        }
      },
      chooseCarShip(row, type) {
        this.clearTableV();
        let data = this.carShipInfo.data;
        let i = this.carShipInfo.i;
        data[i].carShipId = row.id;
        if (type === "ship") {
          data[i].carShipNum = row.shipName;
        } else {
          data[i].carShipNum = row.carNum;
        }
        this.$refs.carShipModal.close();
        this.carShipVisible = false;
      },
      focusEvent(name, i) {
        let refs = this.$refs[name];
        this.buyerNameIndex = i;
        refs.showPanel();
        this.getChainList();
      },
      getChainList() {
        $api.order.querySupplyChainListModel
          .POST({
            data: {
              page: 1,
              rows: 10
            }
          })
          .then(res => {
            this.chainIdPage.total = res.data.total;
            this.chainIdData = res.data.list;
          });
      },
      async querySalesList() {
        let res = await $api.baseUserSales.request("querySalesList");
        if (res.status === 1) {
          let salesList = res.data.rows;
          salesList.forEach((vRow, index) => {
            this.saleMap.set(vRow.salesMan, vRow.salesManager);
          });
          console.log(this.saleMap);
        }
      },
      getDicByParentList() {
        $api.other.getDicByParentModel
          .GET({
            params: {
              page: 1,
              rows: 10
            }
          })
          .then(res => {
            this.dicByParentData = res.data;
          });
      },
      sellerNameCellClickEvent({row}) {
        this.formData[this.buyerNameIndex].buyerName = row.dictText;
        this.$refs.sellerDown.hidePanel();
      },
      setSaleMan(val) {
        this.clearTableV();
      },
      contractBusChange() {
        this.clearTableV();
      },
      impotEvent() {
        let errTimeLine = "";
        let isHaveErr = false;
        this.$refs.xTable
          .readFile({
            types: ["xls", "xlsx"]
          })
          .then(evnt => {
            this.$Spin.show({
              render: h => {
                return h("div", [
                  h("Icon", {
                    class: "demo-spin-icon-load",
                    props: {
                      type: "ios-loading",
                      size: 18
                    }
                  }),
                  h("div", "导入中...")
                ]);
              }
            });
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = ev => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(
                Object.values(workbook.Sheets)[0]
              );
              const tableData = [];
              // 解析数据
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  let beginTime;
                  let endTime;
                  if (vCols[4] === "陆运") {
                    if (vCols[22] && vCols[22] !== '') {
                      beginTime = moment(vCols[22]).format("YYYY-MM-DD HH:mm:ss");
                    }
                    if (vCols[24] && vCols[24] !== '') {
                      endTime = moment(vCols[24]).format("YYYY-MM-DD HH:mm:ss");
                    }
                    if (vCols[22].length < 12 || vCols[24].length < 12) {
                      errTimeLine += `${index},`;
                      isHaveErr = true;
                      if (vCols[22].length < 12) {
                        beginTime = null;
                      }
                      if (vCols[24].length < 12) {
                        endTime = null;
                      }
                    }
                  } else {
                    if (vCols[22] && vCols[22] !== '') {
                      beginTime = moment(vCols[22]).format("YYYY-MM-DD");
                    }
                    if (vCols[24] && vCols[24] !== '') {
                      endTime = moment(vCols[24]).format("YYYY-MM-DD");
                    }
                  }
                  let addTime = moment(vCols[8]).format("YYYY-MM-DD");
                  let receiveGoodsTime = moment(vCols[43]).format("YYYY-MM-DD");

                  const item = {
                    index: index,
                    no: vCols[0],
                    buyerOrdersNum: vCols[1],
                    // buyerOrderId: null,
                    contractNum: vCols[2],
                    // contractId: null,
                    salesManName: vCols[3],
                    contractBusType: vCols[4],
                    contractTitle: vCols[5],
                    // salesManNameXs: vCols[6],
                    buyerName: vCols[6],
                    sellerName: vCols[7],
                    addTime,
                    goodsType: vCols[9],
                    goodsName: vCols[10],
                    rule: vCols[11], // 规格
                    unit: vCols[12], // 单位
                    counts: vCols[13], // 数量
                    price: vCols[14], // 单价
                    amount: vCols[15],
                    buyerAmount: vCols[16] ? vCols[16].trim() : null,
                    priceType: vCols[17],
                    isTax: vCols[18], // 是否含税
                    carShipNum: vCols[19], // 车船号
                    transportationType: vCols[20], // 车船号
                    // beginPlace: vCols[21], // 起运地
                    // endPlace: vCols[23], // 到达地
                    beginTime, // 交接受载期
                    endTime,
                    driverName: vCols[25],
                    driverPhone: vCols[26],
                    isNeedContractImg: vCols[27],
                    collectionName: vCols[28],
                    collectionBank: vCols[29],
                    collectionAccount: vCols[30],
                    prepayment: vCols[31],
                    demurrageAmount: vCols[32],
                    loadDay: vCols[33],
                    payWay: vCols[34],
                    deliveryWay: vCols[35],
                    specificClauseExtra: vCols[36],
                    ifGenerate: vCols[37], // 是否生成物流及结算
                    logisticsNum: vCols[38], // 物流单号
                    goodsCounts: vCols[40], // 装货数量
                    realCount: vCols[41], // 实际数量
                    logisticsNote: vCols[42], // 物流备注
                    receiveGoodsTime, // 结算时间
                    settleAmount: vCols[44], // 结算金额
                    receiveGoodsNote: vCols[45], // 结算摘要
                    fileAddUuidList: [],
                    fileAddUrlList: [],
                    fileUuidList: [],
                    addWay: 1
                  };
                  //     if(vCols[23] == '' || vCols[23] == null) {
                  //     item.endTime = null;
                  //  }
                  if (!vCols[15] && vCols[13] && vCols[14]) {
                    item.amount = Math.round(vCols[13] * vCols[14] * 100) / 100;
                  }
                  let ontractBusObj = this.contractListType.filter(
                    i => i.label === vCols[4]
                  );
                  item.contractBusType =
                    ontractBusObj.length === 1 ? ontractBusObj[0].value : null;

                  const findKey = (obj, value, compare = (a, b) => a === b) => {
                    return Object.keys(obj).find(k => compare(obj[k], value));
                  };
                  if (vCols[39]) {
                    let obj = $C.LogisticsIsTopStatus.map;
                    let val = vCols[39];
                    item.isTop = parseInt(findKey(obj, val));
                  } else {
                    item.isTop = null;
                  }

                  if (vCols[21]) {
                    if (vCols[4] === "陆运") {
                      let beginPlaceArea = [];
                      let address = this.$AddressParse(vCols[21], 0);
                      item.province = address.province;
                      item.city = address.city;
                      item.area = address.area;
                      beginPlaceArea.push(
                        address.province,
                        address.city,
                        address.area
                      );
                      item.beginPlaceArea = beginPlaceArea;
                      // console.log(item.beginPlaceArea);
                      item.beginPlaceAddress = address.detail || address.name;
                    } else {
                      item.beginPlaceArea = [];
                      // console.log(item.beginPlaceArea);
                      item.beginPlaceAddress = vCols[21];
                    }
                  }
                  if (vCols[23]) {
                    if (vCols[4] === "陆运") {
                      let endPlaceArea = [];
                      let endAddress = this.$AddressParse(vCols[23], 0);
                      item.endProvince = endAddress.province;
                      item.endCity = endAddress.city;
                      item.endArea = endAddress.area;
                      endPlaceArea.push(
                        endAddress.province,
                        endAddress.city,
                        endAddress.area
                      );
                      item.endPlaceArea = endPlaceArea;
                      item.endPlaceAddress = endAddress.detail || endAddress.name;
                    } else {
                      item.endPlaceArea = [];
                      item.endPlaceAddress = vCols[23];
                    }
                  }
                  // switch (vCols[4]) {
                  //   case "水运":
                  //     item.contractBusType = 1;
                  //     break;
                  //   case "陆运":
                  //     item.contractBusType = 2;
                  //     break;
                  // }
                  if (vCols[4] === "陆运") {
                    item.prepayment = null;
                    item.demurrageAmount = null;
                    item.loadDay = null;
                    item.payWay = null;
                    item.deliveryWay = null;
                    item.specificClauseExtra = null;
                  }
                  switch (vCols[17]) {
                    case "单价":
                      item.priceType = 1;
                      break;
                    case "包车":
                      item.priceType = 2;
                      break;
                    case "包船":
                      item.priceType = 3;
                      break;
                  }
                  switch (vCols[37]) {
                    case "是":
                      item.ifGenerate = 1;
                      break;
                    case "否":
                      item.ifGenerate = 0;
                      break;
                  }
                  item.salesManNameXs = this.saleMap.get(item.salesManName);
                  tableData.push(item);
                }
              });
              this.formData = tableData;
              // debugger
            };
            fileReader.readAsBinaryString(files[0]);
            setTimeout(() => {
              let arr = this.$refs.xTable.getTableData().tableData;
              arr.forEach((item, index) => {
                if (item.contractBusType === 2) {
                  this.loadCity(item.province, index, 1, true);
                  this.loadCity(item.endProvince, index, 2, true);
                  this.loadArea(item.province, item.city, index, 1, true);
                  this.loadArea(item.endProvince, item.endCity, index, 2, true);
                }
              });
              this.$Spin.hide();
              if (isHaveErr) {
                this.$XModal.alert({
                  message: "第" + errTimeLine + "行，日期格式错误",
                  status: "error"
                });
                isHaveErr = false;
              }
            }, 3000);
          });
      }
    }
  };
</script>

<style>
  .chainId-dropdown {
    width: 400px;
    height: 300px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    position: relative;
  }

  .chainId-dropdown .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 999;
  }

  .chainId-dropdown .ivu-input {
    border-radius: 0;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .modal-container {
    position: relative;
    height: 100%;
  }
</style>